



















import { defineComponent, reactive, SetupContext } from '@vue/composition-api';

interface Props {
  confirmMessage: string;
}

interface State {
  dialog: boolean;
}

const Component = defineComponent({
  name: 'Confirmation',

  props: {
    confirmMessage: String,
  },

  setup(props: Props, { emit }: SetupContext) {
    const state = reactive({
      dialog: false,
    }) as State;

    function no() {
      state.dialog = false;
      emit('confirmed', false);
    }

    function yes() {
      state.dialog = false;
      emit('confirmed', true);
    }

    return {
      state,
      no,
      yes,
    };
  },
});

export default Component;
